
<div class="sign-in-page">
    <div class="sign-in-container">
        <div class="signin-header-container">
            <img class="company-image" src="../../../assets/images/financial-management-18.png" alt="project image">
            <span class="sign-in-header">FINANCE MANAGEMENT SYSTEM</span>
        </div>
        <div class="sign-in-title-continer">
            <span>Register User</span>
        </div>

        <div class="login mt-3 px-2 py-2">
            <form [formGroup]="userRegFg" autocomplete="off" (ngSubmit)="registerUser()">
                <div class="form-group required">
                    <label for="exampleInputEmail1">Email address</label>
                    <input type="email" class="form-control" id="exampleInputEmail1" 
                            aria-describedby="emailHelp" placeholder="Enter email"
                            formControlName="username" name="username" autocomplete="off">
                    <small *ngIf="userRegFg.controls['username'].dirty && userRegFg.controls['username'].invalid" class="warn">Please enter valid email id!</small>
                </div>
                <div class="form-group required">
                    <label for="inputname">Name</label>
                    <input type="text" class="form-control" id="inputname" 
                            placeholder="Enter name"
                            formControlName="displayName" name="displayName" autocomplete="off">
                    <small *ngIf="userRegFg.controls['displayName'].dirty && userRegFg.controls['displayName'].invalid" class="warn">Please enter user name!</small>
                </div>
                <div class="form-group mt-2 required">
                    <label for="passwordinput">Password</label>
                    <input type="password" class="form-control" id="passwordinput" placeholder="Password" required
                        formControlName="password" name="password" autocomplete="off" aria-describedby="passwordHint">
                        <small *ngIf="userRegFg.controls['password'].dirty && userRegFg.controls['password'].invalid" class="warn">{{getControlErrMsg(userRegFg.controls['password'])}}<br></small>
                        <small id="passwordHint">Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character</small>
                </div>
                <div class="form-group mt-2 required">
                    <label for="confirmpasswordinput">Confirm Password</label>
                    <input type="password" class="form-control" id="confirmpasswordinput" placeholder="Confirm Password"
                        formControlName="confirmPassword" name="confirmPassword" autocomplete="off">
                        <small *ngIf="userRegFg.controls['confirmPassword'].dirty && userRegFg.controls['confirmPassword'].invalid" class="warn">{{getControlErrMsg(userRegFg.controls['confirmPassword'])}}</small>
                </div>
                <div class="login-submit-container mt-3">
                    <button type="submit" class="btn btn-primary login-submit-btn" [disabled]="!userRegFg.valid">Submit</button>
                </div>
            </form>
            <div class="line mt-3"></div>
            <div class="login-bottom-section mt-2">
                <span>Account already exists? - <a routerLink="/sign-in">Login</a></span>
            </div>
            <div class="line mt-3"></div>
        </div>
    </div>
</div>
